import { useEffect, useState } from 'react';
import Hero from './components/Hero';
import Fleet from './components/Fleet';
import Rates from './components/Rates';
import Requirements from './components/Requirements';
import Booking from './components/Booking';
import About from './components/About';
import Contact from './components/Contact';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function Home() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar isScrolled={isScrolled} />
      <Hero />
      <Fleet />
      <Rates />
      <Requirements />
      <Booking />
      <About />
      <Contact />
      <Footer />
    </div>
  );
}